<template>
  <div class="mobile-leadership-care">
    <!-- 固定Banner图 -->
    <div class="mobile-leadership-banner">
      <img 
        :src="require('@/assets/aboutSailHero/img/banner_1.jpg')" 
        alt="领导关怀"
        class="mobile-leadership-banner__image"
      />
      <div class="mobile-leadership-banner__overlay"></div>
      <div class="mobile-leadership-banner__content">
        <h1 class="mobile-leadership-banner__title">领导关怀</h1>
        <p class="mobile-leadership-banner__subtitle">LEADERSHIP CARE</p>
      </div>
    </div>

    <!-- 图片画廊 -->
    <div class="mobile-leadership-container">
      <!-- 加载状态 -->
      <div class="mobile-leadership-loading" v-if="loading && careList.length === 0">
        <div class="mobile-leadership-loading__spinner"></div>
        <p class="mobile-leadership-loading__text">加载中...</p>
      </div>

      <!-- 图片网格 -->
      <div v-else-if="displayList && displayList.length > 0">
        <div class="mobile-leadership-grid">
          <div
            v-for="(item, index) in displayList"
            :key="item.id || index"
            class="mobile-leadership-item"
            @click="openImage(item)"
          >
            <img 
              v-if="item.fileUrl" 
              :src="item.fileUrl" 
              :alt="`领导关怀${index + 1}`"
              class="mobile-leadership-item__image"
            />
            <span v-else class="mobile-leadership-item__placeholder">📷</span>
          </div>
        </div>

        <!-- 查看更多按钮 -->
        <div class="mobile-leadership-loadmore" v-if="hasMore">
          <button 
            class="mobile-leadership-loadmore__button"
            @click="showMore"
            :disabled="loadingMore"
          >
            <span v-if="loadingMore">加载中...</span>
            <span v-else>查看更多</span>
          </button>
        </div>
        
        <!-- 全部加载完毕提示 -->
        <div class="mobile-leadership-loadmore" v-else>
          <p class="mobile-leadership-loadmore__text">已加载全部内容</p>
        </div>
      </div>

      <!-- 空状态 -->
      <div class="mobile-leadership-empty" v-else>
        <div class="mobile-leadership-empty__icon">🖼️</div>
        <p class="mobile-leadership-empty__text">暂无领导关怀照片</p>
        <p class="mobile-leadership-empty__subtext">敬请期待更多内容</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileLeadershipCare",
  data() {
    return {
      careList: [],             // 完整的领导关怀列表（倒序）
      displayCount: 6,          // 当前显示的数量
      loading: false,           // 初始加载状态
      loadingMore: false,       // 加载更多状态
      pageSize: 100             // 一次性加载所有数据
    };
  },
  computed: {
    // 当前显示的列表（取前displayCount条）
    displayList() {
      return this.careList.slice(0, this.displayCount);
    },
    // 是否还有更多数据可以显示
    hasMore() {
      return this.displayCount < this.careList.length;
    }
  },
  methods: {
    /**
     * 获取领导关怀列表（一次性加载所有数据）
     */
    fetchCareList() {
      const _this = this;
      _this.loading = true;

      _this.$api.post(
        "/Client/getLeadershipCare",
        {
          pageSize: _this.pageSize,
          pageIndex: 1
        },
        function (res) {
          _this.loading = false;

          if (res.code === "200") {
            const data = res.data || [];

            // 倒序排列（最新的在前）
            _this.careList = data.reverse();
            
            // 重置显示数量为6
            _this.displayCount = 6;
          }
        },
        function (error) {
          _this.loading = false;
          console.error('获取领导关怀列表失败:', error);
        }
      );
    },

    /**
     * 查看更多（每次增加6张）
     */
    showMore() {
      if (this.hasMore) {
        this.loadingMore = true;
        
        // 模拟加载延迟，提升用户体验
        setTimeout(() => {
          this.displayCount += 6;
          this.loadingMore = false;
        }, 300);
      }
    },

    /**
     * 打开图片大图
     * @param {Object} item - 领导关怀项数据
     */
    openImage(item) {
      if (item.fileUrl) {
        window.open(item.fileUrl, '_blank');
      }
    }
  },

  mounted() {
    // 页面加载时获取数据
    this.fetchCareList();
  }
};
</script>

<style scoped>
@import '../../../assets/aboutSailHero/css/leadership-care-mobile.css';
</style>

